import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ManagerDashboardService } from '../../services/manager-dashboard.service';
import { LoggingService } from '../../services/logging.service';
import { Team } from '../../models/team';
import { TenantRouterService } from '../../services/tenant-router.service';
declare var bootstrap: any; 


@Component({
  selector: 'app-register-dashboard',
  standalone: false,
  templateUrl: './register-dashboard.component.html',
  styleUrl: './register-dashboard.component.scss'
})
export class RegisterDashboardComponent implements OnInit {
  teams: Team[] = [];
  managerId!: number;
  teamSubscription: any;
  selectedTeamLength: number = 0;
  teamId!:number;


   @ViewChild('teamModal', { static: false }) teamModalEl!: ElementRef;
   @ViewChild('teamToast') teamToastEl!: ElementRef;
   users: any;
   selectedUsers: any;



  constructor(private router : Router,
    private managerDashboardService: ManagerDashboardService,
    private loggingService: LoggingService,
    private tenantRouter: TenantRouterService
  ) { }
 

  ngOnInit() {
    this.loggingService.logDebug("Getting the managerId from session storage");
    const managerid = sessionStorage.getItem('manager_id');
    if(managerid) {
      this.managerId = parseInt(managerid, 10);
    }
    this.teamSubscription = this.managerDashboardService.getAllTeams(this.managerId).subscribe(
      (teams: Team[]) => {
        console.log('Fetched teams:', teams);
        this.teams = teams;

         this.managerDashboardService.setTeams(teams);
        
      }
    );
  }

  ngAfterViewInit() {
  document.addEventListener('hidden.bs.modal', () => {
    document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove());
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('padding-right');
  });
}

  addTeam() {
    //this.router.navigate(['add-team']);
  }

  goToTeam(teamId: number): void {
  this.tenantRouter.navigate(['team', teamId]);
}


  addUser() {
    this.tenantRouter.navigate('add-user');
  }

  onTeamAdded(newTeam: Team) {

    if (!newTeam.users) {
      newTeam.users = [];
    }
    
  this.teams.push(newTeam);

  const modalEl = document.getElementById('addTeamModal');
  const modal = bootstrap.Modal.getOrCreateInstance(modalEl!);

  // Listen for modal hidden event
  modalEl?.addEventListener('hidden.bs.modal', () => {
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('padding-right');

    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
  }, { once: true });

  modal.hide();

   const toast = new bootstrap.Toast(this.teamToastEl.nativeElement, { delay: 3000 });
    toast.show();
}

onTeamChange() {
  this.teamId = Number(this.selectedTeam);

  const selectedTeamObj = this.teams.find(team => team.teamId === this.teamId);

  if (selectedTeamObj) {
    this.selectedTeamLength = selectedTeamObj.users ? selectedTeamObj.users.length : 0;  
    this.users = selectedTeamObj.users;
  } else {
    this.selectedTeamLength = 0;
    this.users = [];
  }
  this.selectedUsers = [];
}
  selectedTeam(selectedTeam: any): number {
    throw new Error('Method not implemented.');
  }
  



}
